import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveTickets } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, ContentrArea, Maki } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const TicketListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, tickets } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveTickets();
  }, [language]);

  return (
    <article className="ticket-listing">
      {/* <Container fluid className="header-image">
        <h1 className="claim">
          ELBJAZZ
          <br />
          TICKETSHOP
          <br />
          <span className="subclaim">09. & 10. JULI 2027</span>
        </h1>
      </Container> */}
      <div className="hero-slider d-none d-lg-block mt-1">
        <img
          src={require('./assets/images/Elbjazz_VVK_2027_FB-Event-Header.jpg')}
          alt="ELBJAZZ 2027 - 09. und 10. Juli 2027"
          className="img-fluid w-100"
        />
      </div>
      <div className="hero-slider d-lg-none mt-1">
        <img
          src={require('./assets/images/Elbjazz_VVK_2027_Website.jpg')}
          alt="ELBJAZZ 2027 - 09. und 10. Juli 2027"
          className="img-fluid w-100"
        />
      </div>
      <Helmet>
        <title>{t(`TICKETLISTING.TITLE`)}</title>
        <body className="ticket-listing-page" />
      </Helmet>

      <Container className="pt-3">
        <ContentrArea id="before-listing" />
      </Container>

      <Container className="list-page mt-4">
        {/* <h1 className="text-center mb-4">{t(`TICKETLISTING.TITLE`)}</h1> */}
        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.TICKETS`)} />
        ) : tickets.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry
            id="ticket-listing"
            products={tickets}
            type={Maki}
            filters="off"
            showLocation={false}
            showSubtitle
            columnClassName="col-sm-6 col-md-6 col-lg-4"
          />
        )}
      </Container>

      <Container className="pb-5">
        <ContentrArea id="after-ticket-listing" />
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  return {
    tickets,
    loading,
  };
};

const mapDispatchToProps = {
  receiveTickets,
};

export default React.memo(TicketListing);
